const services = [
  {
    title: "Towing & Transport",
    description:
      "Full-service towing for cars, SUVs, trucks, and motorcycles. Standard and heavy-duty towing with a modern fleet of flatbeds and wheel-lifts for all vehicle types.",
    icon: "ri-truck-line",
    image:
      "https://public.readdy.ai/ai/img_res/f4c6e09b30fa443215f438d428aca081.jpg",
  },
  {
    title: "Vehicle Recovery",
    description:
      "Specialized recovery operations for all vehicle types and sizes. Expert handling of complex recovery scenarios with professional-grade equipment and experienced operators.",
    icon: "ri-tools-line",
    image:
      "https://readdy.ai/api/search-image?query=heavy%20duty%20tow%20truck%20recovery%20operation%20on%20dark%20highway%2C%20dramatic%20cinematic%20lighting%2C%20professional%20recovery%20equipment%2C%20industrial%20commercial%20scene%2C%20dark%20moody%20atmosphere%2C%20emergency%20lights%2C%20professional%20operators%2C%20night%20scene&width=600&height=750&seq=svc002&orientation=portrait",
  },
  {
    title: "Heavy-Duty & Equipment Transport",
    description:
      "Transport of boats, containers, forklifts, and large industrial equipment. Landoll and specialty trailer capabilities for oversized and low-clearance loads.",
    icon: "ri-ship-line",
    image:
      "https://readdy.ai/api/search-image?query=heavy%20equipment%20transport%20truck%20carrying%20industrial%20machinery%20on%20highway%2C%20dark%20dramatic%20sky%2C%20professional%20commercial%20transport%2C%20cinematic%20wide%20angle%2C%20powerful%20industrial%20scene%2C%20dark%20moody%20lighting%2C%20premium%20logistics&width=600&height=750&seq=svc003&orientation=portrait",
  },
  {
    title: "Impound & Storage",
    description:
      "Secure impound facilities accommodating up to 300 vehicles, protected by electric gates and 24-hour surveillance. Private property impound management for commercial owners.",
    icon: "ri-lock-2-line",
    image:
      "https://readdy.ai/api/search-image?query=secure%20vehicle%20impound%20storage%20facility%20at%20night%2C%20electric%20security%20gates%2C%20surveillance%20cameras%2C%20dark%20industrial%20setting%2C%20dramatic%20lighting%2C%20professional%20secure%20compound%2C%20rows%20of%20vehicles%2C%20cinematic%20photography&width=600&height=750&seq=svc004&orientation=portrait",
  },
  {
    title: "Roadside Assistance",
    description:
      "Emergency roadside support including jump-starts, flat tire changes, lockouts, and winch-out services. Rapid response for stranded motorists across the Inland Empire.",
    icon: "ri-roadster-line",
    image:
      "https://readdy.ai/api/search-image?query=roadside%20assistance%20technician%20helping%20stranded%20vehicle%20at%20night%2C%20professional%20service%20truck%2C%20dramatic%20highway%20lighting%2C%20dark%20moody%20atmosphere%2C%20emergency%20response%2C%20cinematic%20photography%2C%20industrial%20commercial%20scene&width=600&height=750&seq=svc005&orientation=portrait",
  },
  {
    title: "Law Enforcement & Municipal",
    description:
      "Contracted towing and vehicle abatement services for the City of Riverside, City of Moreno Valley, and state and local law enforcement agencies throughout Southern California.",
    icon: "ri-government-line",
    image:
      "https://readdy.ai/api/search-image?query=professional%20tow%20truck%20working%20with%20law%20enforcement%20at%20night%2C%20police%20lights%2C%20dark%20dramatic%20scene%2C%20municipal%20contract%20towing%2C%20professional%20operators%2C%20cinematic%20photography%2C%20dark%20highway%2C%20authoritative%20commercial%20scene&width=600&height=750&seq=svc006&orientation=portrait",
  },
];

export default function Services() {
  return (
    <section id="services" className="bg-[#0a0a0c] py-28 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase">What We Do</span>
            <div className="w-8 h-px bg-[#D4AF37]"></div>
          </div>
          <h2
            className="text-white font-black text-4xl md:text-5xl mb-4"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Professional Recovery Services
          </h2>
          <p className="text-[#888] text-lg max-w-2xl mx-auto">
            A full-spectrum fleet and experienced team ready to handle any towing, transport, or recovery situation — from a single vehicle to large-scale fleet operations.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-lg cursor-pointer"
              style={{ aspectRatio: "4/5" }}
            >
              {/* Background image */}
              <img
                src={svc.image}
                alt={svc.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c]/95 via-[#0a0a0c]/40 to-transparent"></div>
              {/* Gold border on hover */}
              <div className="absolute inset-0 border border-transparent group-hover:border-[#D4AF37]/40 rounded-lg transition-all duration-300"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="w-10 h-10 flex items-center justify-center mb-3">
                  <i className={`${svc.icon} text-[#D4AF37] text-2xl`}></i>
                </div>
                <h3
                  className="text-white font-bold text-xl mb-2"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {svc.title}
                </h3>
                <p className="text-[#b8b8b8] text-sm leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 max-h-0 group-hover:max-h-40 overflow-hidden">
                  {svc.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] font-semibold px-8 py-4 rounded-sm tracking-wider uppercase text-sm hover:bg-[#D4AF37] hover:text-black transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Request Specialized Service
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
